/* Matty Miller Studio: short product names in the few places the theme prints the full SEO title
   (the sticky Add to cart bar on product pages, the pickup pop-up and the search pop-up results).
   Same rule as snippets/mm-product-name.liquid: "100% Silk Scarf: Lupine - Wolf Wildflower Pattern"
   shows as "Lupine - 100% Silk Scarf"; other products show the part before " – " or " | ".
   The real product titles in Shopify (and SEO) are never changed. Nov 2, 2026. */
(function () {
  var SEL = '.sticky-add-to-cart__title, .resource-card__title, .pickup-location__h4';

  function shortName(full) {
    var s = String(full || '').trim();
    var isScarf = /^100% Silk Scarf/i.test(s);
    s = s.split(' – ')[0].split(' | ')[0];
    if (s.indexOf(': ') > -1) { var parts = s.split(': '); s = parts[parts.length - 1]; }
    if (isScarf) s = s.split(' - ')[0].trim() + ' - 100% Silk Scarf';
    return s.trim();
  }

  function fix(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.children.length) return;
      var full = el.textContent.trim();
      if (!full || el.getAttribute('data-mm-short') === full) return;
      var short = shortName(full);
      if (short && short !== full) {
        el.textContent = short;
        el.setAttribute('data-mm-short', short);
        el.setAttribute('title', short);
      }
    });
  }

  function start() {
    fix();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(fix, 30);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
